// frontend/src/components/ReceiptPrinter.js
// 既存の Electron preload の printReceipt メソッドだけを使います。
import { buildSmartDetaxPayloads } from "../utils/smartDetaxQr";

export const printReceipt = async (receipt, showAlert) => {
  try {
    if (!window.electronAPI?.printReceipt) {
      throw new Error("Electronのレシート印刷機能が見つかりません");
    }
    if (!receipt?.id) throw new Error("確定済みのレシート番号がありません");
    // お客様用レシートには SmartDetax QR を一切印刷しません。
    const result = await window.electronAPI.printReceipt({
      ...receipt,
      smartDetaxMode: "regular",
      smartDetaxPayloads: undefined,
    });
    if (result?.success === false) throw new Error(result.reason || "印刷処理に失敗しました");
    return true;
  } catch (error) {
    console.error("[ReceiptPrinter] お客様用レシート印刷失敗:", error);
    showAlert?.(`レシートを出力できません：${error.message}`);
    return false;
  }
};

export const prepareSmartDetaxReceipt = (receipt) => {
  if (!receipt?.isTaxFree) throw new Error("免税販売のレシートではありません");
  const payloads = buildSmartDetaxPayloads(receipt, {
    defaultTaxRate: 10,
    defaultGoodsType: 1,
    maxBytes: 650,
    maxItemsPerQr: 8,
    janFeatureMinUnitPrice: 20000,
    taxAmounts: receipt.taxAmountsByRate,
  });
  return { ...receipt, smartDetaxPayloads: payloads };
};

export const getSmartDetaxImages = async (preparedReceipt) => {
  if (!window.electronAPI?.printReceipt) {
    throw new Error("ElectronのQR生成機能が見つかりません");
  }
  const result = await window.electronAPI.printReceipt({
    ...preparedReceipt,
    smartDetaxMode: "images",
  });
  if (result?.success === false || !Array.isArray(result?.images)) {
    throw new Error(result?.reason || "QR画像を生成できませんでした");
  }
  return result.images;
};

export const printSmartDetaxReceipt = async (receipt, showAlert) => {
  try {
    if (!window.electronAPI?.printReceipt) {
      throw new Error("Electronのレシート印刷機能が見つかりません");
    }
    const prepared = Array.isArray(receipt?.smartDetaxPayloads) &&
      receipt.smartDetaxPayloads.length > 0
      ? receipt
      : prepareSmartDetaxReceipt(receipt);
    const result = await window.electronAPI.printReceipt({
      ...prepared,
      smartDetaxMode: "print",
    });
    if (result?.success === false) throw new Error(result.reason || "印刷処理に失敗しました");
    return true;
  } catch (error) {
    console.error("[ReceiptPrinter] SmartDetax印刷失敗:", error);
    showAlert?.(`SmartDetaxレシートを印刷できません：${error.message}`);
    return false;
  }
};
